var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]),_c('v-card-text',[_c('pie-chart',{attrs:{"data":_vm.data,"download":true}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }